




































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import UiWindow from '@/components/UiWindow.vue';
@Component({components: {UiWindow}})
export default class Victory extends Vue {

  @Prop() public visible!: boolean;

  private isVisible: boolean = false;

  @Watch('visible') private onVisibleChanged(): void {
    this.isVisible = this.visible;
  }

  @Watch('isVisible') private onIsVisibleChanged(): void {
    this.$emit('update:visible', this.isVisible);
  }
}
